export const getPossibleTranslation = (baseName, callback) => {
  const keysFromBaseName = baseName.split(' ');
  const containsDigitRegex = /\d/;
  const withoutNumber = keysFromBaseName.filter(item => !containsDigitRegex.test(item));

  if (withoutNumber.length === 1) {
    const regex = new RegExp(withoutNumber[0], 'gi');

    baseName = baseName.replace(regex, callback(withoutNumber[0].toUpperCase()));
  }
  return baseName;
}